import { render } from "./TotalScorePopup.vue?vue&type=template&id=ca4af696&lang=pug"
import script from "./TotalScorePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalScorePopup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__